import React, { useState } from 'react';

// เปลี่ยนรหัสผ่านของตัวเอง (ต้องยืนยันรหัสเดิมก่อน) — ไม่ใช้อีเมล จึงไม่ติดโควตาอีเมลของ Supabase
const box = { width: 'min(420px,94vw)', background: '#fffdf5', border: '1px solid #e2cc82', borderRadius: 10, padding: 18, boxShadow: '0 12px 40px #0003' };
const inp = { width: '100%', padding: 10, border: '1px solid #cbd5e1', borderRadius: 8, boxSizing: 'border-box', margin: '5px 0 12px' };
const btn = { padding: '9px 14px', border: 0, borderRadius: 8, cursor: 'pointer' };

export default function ChangePassword({ supabase, email, onClose, forced, onDone }) {
  const [oldPw, setOldPw] = useState(''), [pw, setPw] = useState(''), [pw2, setPw2] = useState('');
  const [show, setShow] = useState(false), [busy, setBusy] = useState(false);
  const [err, setErr] = useState(''), [done, setDone] = useState(false);

  async function save(e) {
    e.preventDefault();
    if (busy) return;
    setErr('');
    if (pw.length < 8) { setErr('รหัสผ่านใหม่ต้องยาวอย่างน้อย 8 ตัวอักษร'); return; }
    if (pw !== pw2) { setErr('รหัสผ่านใหม่ทั้งสองช่องไม่ตรงกัน'); return; }
    if (pw === oldPw) { setErr('รหัสผ่านใหม่ต้องไม่ซ้ำกับรหัสเดิม'); return; }
    setBusy(true);
    // ยืนยันว่าเป็นเจ้าของบัญชีจริง (กันคนอื่นมาเปลี่ยนรหัสตอนเครื่องเปิดทิ้งไว้)
    const check = await supabase.auth.signInWithPassword({ email, password: oldPw });
    if (check.error) { setBusy(false); setErr('รหัสผ่านปัจจุบันไม่ถูกต้อง'); return; }
    const { error } = await supabase.auth.updateUser({ password: pw });
    setBusy(false);
    if (error) { setErr('เปลี่ยนรหัสผ่านไม่สำเร็จ: ' + (error.message || 'กรุณาลองใหม่')); return; }
    try { await supabase.schema('whcore').rpc('clear_must_change_pw'); } catch { /* ยังไม่รัน W21 */ }
    setOldPw(''); setPw(''); setPw2(''); setDone(true);
  }

  return (
    <div role="dialog" aria-modal="true" aria-label="เปลี่ยนรหัสผ่าน" style={{ position: 'fixed', inset: 0, zIndex: 2000, background: 'rgba(33,28,20,.5)', display: 'grid', placeItems: 'center', padding: 12, fontFamily: 'sans-serif' }}>
      {done ? (
        <div style={box}>
          <h3 style={{ marginTop: 0, color: '#2f7d32' }}>✅ เปลี่ยนรหัสผ่านเรียบร้อย</h3>
          <p style={{ fontSize: 14 }}>ครั้งต่อไปให้ใช้รหัสผ่านใหม่ในการเข้าสู่ระบบ</p>
          <div style={{ textAlign: 'right' }}><button onClick={onDone || onClose} style={{ ...btn, background: '#bd322c', color: '#fff' }}>{forced ? 'เข้าใช้งานระบบ' : 'ปิด'}</button></div>
        </div>
      ) : (
        <form onSubmit={save} style={box}>
          <h3 style={{ margin: '0 0 4px' }}>🔑 {forced ? 'ตั้งรหัสผ่านใหม่ก่อนใช้งาน' : 'เปลี่ยนรหัสผ่าน'}</h3>
          {forced && <p style={{ margin: '0 0 10px', fontSize: 13, background: '#fff7e8', border: '1px solid #f5b544', borderRadius: 8, padding: 8 }}>ผู้ดูแลระบบรีเซ็ตรหัสผ่านให้คุณ — ใส่ <b>รหัสผ่านชั่วคราว</b> ที่ได้รับในช่องแรก แล้วตั้งรหัสผ่านใหม่ของคุณเอง</p>}
          <p style={{ margin: '0 0 12px', fontSize: 12, color: '#64748b' }}>บัญชี {email}</p>
          <label htmlFor="cp-old" style={{ fontSize: 13 }}>{forced ? 'รหัสผ่านชั่วคราว' : 'รหัสผ่านปัจจุบัน'}</label>
          <input id="cp-old" type={show ? 'text' : 'password'} required autoComplete="current-password" value={oldPw} onChange={e => setOldPw(e.target.value)} style={inp} />
          <label htmlFor="cp-new" style={{ fontSize: 13 }}>รหัสผ่านใหม่ (อย่างน้อย 8 ตัวอักษร)</label>
          <input id="cp-new" type={show ? 'text' : 'password'} required autoComplete="new-password" value={pw} onChange={e => setPw(e.target.value)} style={inp} />
          <label htmlFor="cp-new2" style={{ fontSize: 13 }}>พิมพ์รหัสผ่านใหม่อีกครั้ง</label>
          <input id="cp-new2" type={show ? 'text' : 'password'} required autoComplete="new-password" value={pw2} onChange={e => setPw2(e.target.value)} style={inp} />
          <label style={{ display: 'flex', gap: 7, alignItems: 'center', fontSize: 13, marginBottom: 10 }}><input type="checkbox" checked={show} onChange={e => setShow(e.target.checked)} /> แสดงรหัสผ่าน</label>
          {err && <p role="alert" style={{ padding: 9, border: '1px solid #d48c71', borderRadius: 8, background: '#fff0e9', color: '#882b19', fontSize: 13 }}>{err}</p>}
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            {forced ? <button type="button" onClick={onClose} disabled={busy} style={{ ...btn, background: '#e2e8f0', color: '#334155' }}>ออกจากระบบ</button>
              : <button type="button" onClick={onClose} disabled={busy} style={{ ...btn, background: '#fbd973', color: '#74251d' }}>ยกเลิก</button>}
            <button type="submit" disabled={busy} style={{ ...btn, background: '#bd322c', color: '#fff', opacity: busy ? 0.6 : 1 }}>{busy ? 'กำลังบันทึก…' : 'บันทึกรหัสผ่านใหม่'}</button>
          </div>
        </form>
      )}
    </div>
  );
}
